import { render, staticRenderFns } from "./FacturationTable.vue?vue&type=template&id=31a55417&scoped=true"
import script from "./FacturationTable.vue?vue&type=script&lang=js"
export * from "./FacturationTable.vue?vue&type=script&lang=js"
import style0 from "./FacturationTable.vue?vue&type=style&index=0&id=31a55417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a55417",
  null
  
)

export default component.exports